const domain = "https://marukisuzukiku.jp";
const title = "マルキ鈴菊商店";
const imageurl = `${domain}/img/`;

exports.setMeta = meta => {
  if (meta.subtitle === undefined) {
    document.title = title;
    document
      .querySelector("meta[property='og:title']")
      .setAttribute("content", `${title}`);
  } else {
    document.title = `${meta.subtitle} - ${title}`;
    document
      .querySelector("meta[property='og:title']")
      .setAttribute("content", `${meta.subtitle} - ${title}`);
  }
  if (meta.description === undefined) {
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", "");
    document
      .querySelector("meta[property='og:description']")
      .setAttribute("content", "");
  } else {
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", `${meta.description}`);
    document
      .querySelector("meta[property='og:description']")
      .setAttribute("content", `${meta.description}`);
  }
  if (meta.path === undefined) {
    document
      .querySelector("link[rel='canonical']")
      .setAttribute("href", `${domain}/`);
    document
      .querySelector("meta[property='og:url']")
      .setAttribute("content", `${domain}/`);
    document
      .querySelector("meta[property='og:type']")
      .setAttribute("content", `website`);
  } else {
    document
      .querySelector("link[rel='canonical']")
      .setAttribute("href", `${domain}${meta.path}`);
    document
      .querySelector("meta[property='og:url']")
      .setAttribute("content", `${domain}${meta.path}`);
    document
      .querySelector("meta[property='og:type']")
      .setAttribute("content", `artcle`);
  }
  if (meta.image === undefined) {
    document
      .querySelector("meta[property='og:image']")
      .setAttribute("content", `${imageurl}top.JPG`);
  } else {
    document
      .querySelector("meta[property='og:image']")
      .setAttribute("content", `${imageurl}${meta.image}`);
  }
  if (meta.path === "/not-found") {
    document
      .querySelector("meta[name='robots']")
      .setAttribute("content", `noindex, nofollow`);
  } else {
    document
      .querySelector("meta[name='robots']")
      .setAttribute("content", `index, follow`);
  }
};
